export default {
  midlayer: {
    uri: {
      'wpplugins-admin.tmm-technology.com' : process.env.REACT_APP_MIDLAYER_ENTRYPOINT,
      'wpplugins-admin.tmm-technology.local': process.env.REACT_APP_MIDLAYER_ENTRYPOINT_LOCAL,
    }
  },
}